import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/browse/")({
  beforeLoad({ context: { user } }) {
    if (
      !user.hasRole(["blis_lab_manager", "blis_lab_tech", "blis_lab_assistant"])
    ) {
      throw notFound();
    }
  },
});
